import { motion } from "framer-motion";
import { BarChart, Zap } from "lucide-react";
import { useTheme } from "../../../../context/ThemeContext";

const CaseStudies = () => {
  const { isDarkTheme } = useTheme();
  const caseStudies = [
    {
      title: "Offshore Drilling Optimization",
      icon: <Zap className="w-8 h-8" />,
      results: "32% increase in drilling efficiency",
      content: "Implemented real-time ML models for trajectory optimization"
    },
    {
      title: "Reservoir Recovery Boost",
      icon: <BarChart className="w-8 h-8" />,
      results: "18% higher recovery rate",
      content: "AI-driven fluid dynamics simulation in mature fields"
    }
  ];

  return (
    <section 
      id="casestudies" 
      className={`${isDarkTheme ? 'bg-black' : 'bg-white'} py-24 px-4`}
    >
      <div className="max-w-7xl mx-auto">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className={`text-3xl font-bold text-center mb-16 ${
            isDarkTheme ? 'text-amber-400' : 'text-amber-600'
          }`}
        >
          Proven Industry Solutions
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8">
          {caseStudies.map((study, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              className={`group ${
                isDarkTheme
                  ? 'bg-gray-900 border-gray-700 hover:bg-gray-800'
                  : 'bg-white border-gray-200 hover:bg-amber-50'
              } border rounded-xl p-8 shadow-lg hover:shadow-xl transition-all cursor-pointer`}
            >
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${
                  isDarkTheme 
                    ? 'bg-gray-800 text-amber-400' 
                    : 'bg-amber-100 text-amber-600'
                } transition-colors duration-300 group-hover:bg-amber-500/20`}>
                  {study.icon}
                </div>
                <div className="space-y-2">
                  <h3 className={`text-xl font-semibold ${
                    isDarkTheme 
                      ? 'text-white' 
                      : 'text-gray-800'
                  }`}>
                    {study.title}
                  </h3>
                  <p className={`font-medium ${
                    isDarkTheme 
                      ? 'text-amber-400' 
                      : 'text-amber-600'
                  }`}>
                    {study.results}
                  </p>
                  <p className={`${
                    isDarkTheme 
                      ? 'text-gray-300' 
                      : 'text-gray-600'
                  }`}>
                    {study.content}
                  </p>
                </div>
              </div>
              {/* Hover Border */}
              <div className={`absolute inset-0 border-2 border-transparent group-hover:${
                isDarkTheme 
                  ? 'border-amber-400/20' 
                  : 'border-amber-600/20'
              } rounded-xl transition-all pointer-events-none`} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;